<kendo-dialog-titlebar>
    {{'claims-center.claimDocumentation.setDocumentDescription' | translate}}
</kendo-dialog-titlebar>

<form [formGroup]="documentDataForm">
    <div fxLayout="column" fxLayoutGap='15px'>

        <textarea-input-ctrl [caption]="'claims-center.claimDocumentation.description'"
            [formControlName]="'description'" [settings]="{fxFill:true, rows:2}">
        </textarea-input-ctrl>
    </div>
</form>

<kendo-dialog-actions>
    <button kendoButton (click)="confirm()" [primary]="true" submit>{{'global.confirm' | translate}}</button>
</kendo-dialog-actions>